import { Component } from '@verndale/core';
import { nanoid } from 'nanoid';

import breakpoints from '../utils/breakpoints';

class HeaderLinkGroup extends Component {
  setupDefaults() {
    this.dom = {
      $header: this.el._$('.header__link-group-header'),
      $list: this.el._$('.header__link-group-list')
    };

    this.buttonId = `id-${nanoid()}`;
    this.listId = `id-${nanoid()}`;
    this.currentViewport = 'lg';
    this.handleViewport();
  }

  addListeners() {
    window._on('resize', ::this.handleViewport);
  }

  handleClick(e) {
    const $header = e.target.closest('.header__link-group-header');
    const $button = e.target.closest('.header__link-group-button');

    if ($button) {
      const isOpen = $button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        $header.classList.remove('header__link-group-header--open');
        $button.setAttribute('aria-expanded', 'false');
      } else {
        $header.classList.add('header__link-group-header--open');
        $button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  handleViewport() {
    if (breakpoints.isTablet()) {
      this.removeAccordionDom();
      this.currentViewport = 'lg';
    } else {
      this.addAccordionDom();
      this.currentViewport = 'xs';
    }
  }

  addAccordionDom() {
    if (this.currentViewport === 'lg') {
      const { $header, $list } = this.dom;
      const label = $header.textContent.trim();
      const visuallyHidden = $header._$('.visually-hidden');
      const visuallyHiddenText = visuallyHidden?.outerHTML;
      const link = $header._$('a').getAttribute('href');
      const externalLink = $header._$('.link-with-external-icon--header');

      if ($header) {
        $header.innerHTML = this.getButton(
          visuallyHidden
            ? label.replace(visuallyHidden.textContent, '')
            : label,
          link,
          visuallyHiddenText,
          externalLink
        );
      }

      if ($list) {
        $list.id = this.listId;
        $list.setAttribute('role', 'region');
        $list.setAttribute('aria-labelledby', this.listId);

        $list.insertAdjacentHTML(
          'afterBegin',
          this.getListLink(
            visuallyHidden
              ? label.replace(visuallyHidden.textContent, '')
              : label,
            link,
            visuallyHiddenText,
            externalLink
          )
        );

        $header._$('button')._on('click', ::this.handleClick);
      }
    }
  }

  removeAccordionDom() {
    if (this.currentViewport === 'xs') {
      const { $header, $list } = this.dom;
      const label = $header.textContent.trim();
      const visuallyHidden = $header._$('.visually-hidden');
      const visuallyHiddenText = visuallyHidden?.outerHTML;
      const link = $header._$('button')?.dataset.href;
      const isExternalLink = $header._$('button')?.dataset.externalLink;

      if ($header) {
        $header.innerHTML = this.getAnchor(
          visuallyHidden
            ? label.replace(visuallyHidden.textContent, '')
            : label,
          link,
          visuallyHiddenText,
          isExternalLink
        );
      }

      if ($list) {
        ['id', 'role', 'aria-labelledby'].forEach((attr) =>
          $list.removeAttribute(attr)
        );
        $list.removeChild($list.firstElementChild);
      }
    }
  }

  getListLink(label, link, visuallyHiddenText, isExternalLink) {
    return `
      <li class="header__link-group-link">
        <a href="${link}" ${isExternalLink ? 'class="link-with-external-icon" target="_blank" ref="noreferrer noopener"' : ''}>
          ${label}${visuallyHiddenText ? visuallyHiddenText : ''}
        </a>
      </li>
    `;
  }

  getAnchor(label, link, visuallyHiddenText, isExternalLink) {
    return `
      <a href="${link}" ${isExternalLink ? 'class="link-with-external-icon--header" target="_blank" ref="noreferrer noopener"' : ''}>
        ${label}${visuallyHiddenText ? visuallyHiddenText : ''}
      </a>
    `;
  }

  getButton(label, link, visuallyHiddenText, externalLink) {
    return `
      <button
        data-external-link="${externalLink ? 'true' : ''}"
        aria-expanded="false"
        class="header__link-group-button"
        aria-controls="${this.listId}"
        data-href="${link}"
        id="${this.buttonId}"
      >
        ${label}${visuallyHiddenText ? visuallyHiddenText : ''}
      </button>
    `;
  }
}

export default HeaderLinkGroup;
